<template>
  <div
    id="emp_edit_and_profile_update"
    class="modal custom-modal fade"
    role="dialog"
    ref="empEditProfileUpdateModal"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Update Profile</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="update_employee_close"
            @click="employee_errors = null"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="row">
              <div class="col-md-12">
                <div class="profile-img-wrap edit-img">
                  <form ref="uploadImageFrm">
                    <img
                      class="inline-block"
                      :src="
                        selectedImage && selectedImage != null
                          ? selectedImage
                          : avatarSrc
                      "
                      alt="user"
                    />
                    <div class="fileupload btn">
                      <span class="btn-text"
                        ><i class="fa fa-user-edit"></i> Edit</span
                      >
                      <input
                        class="upload"
                        name="avatar"
                        type="file"
                        @change="handleImageChange"
                      />
                      <input
                        type="hidden"
                        name="employee_id"
                        :value="employeeData?.id"
                      />
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >First Name <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="employee.first_name"
                    class="form-control"
                    type="text"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.first_name &&
                      employee_errors.first_name != null
                    "
                    >{{ employee_errors?.first_name[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Last Name <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="employee.last_name"
                    class="form-control"
                    type="text"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.last_name &&
                      employee_errors.last_name != null
                    "
                    >{{ employee_errors?.last_name[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Username <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="employee.username"
                    class="form-control"
                    type="text"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.username &&
                      employee_errors.username != null
                    "
                    >{{ employee_errors?.username[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Email <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="employee.email"
                    class="form-control"
                    type="email"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.email &&
                      employee_errors.email != null
                    "
                    >{{ employee_errors?.email[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Password</label>
                  <input
                    v-model="employee.password"
                    class="form-control"
                    type="password"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.password &&
                      employee_errors.password != null
                    "
                    >{{ employee_errors?.password[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Confirm Password</label>
                  <input
                    v-model="employee.confirm_password"
                    class="form-control"
                    type="password"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Kiosk PIN</label>
                  <input
                    v-model="employee.kiosk_pin"
                    class="form-control"
                    type="password"
                    maxlength="4"
                    inputmode="numeric"
                    placeholder="4 digit PIN"
                    @input="restrictKioskPin($event, 'kiosk_pin')"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.kiosk_pin &&
                      employee_errors.kiosk_pin != null
                    "
                    >{{ employee_errors?.kiosk_pin[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Confirm Kiosk PIN</label>
                  <input
                    v-model="employee.kiosk_confirm_pin"
                    class="form-control"
                    type="password"
                    maxlength="4"
                    inputmode="numeric"
                    placeholder="Confirm 4 digit PIN"
                    @input="restrictKioskPin($event, 'kiosk_confirm_pin')"
                  />
                  <span
                    class="text-danger"
                    v-if="kioskPinMismatch"
                    >Kiosk PIN and Confirm PIN do not match</span
                  >
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.kiosk_confirm_pin &&
                      employee_errors.kiosk_confirm_pin != null
                    "
                    >{{ employee_errors?.kiosk_confirm_pin[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Gender</label>
                  <select
                    class="form-select form-select-lg"
                    v-model="employee.gender"
                  >
                    <option
                      v-for="gndr in genders"
                      :key="gndr.key"
                      :value="gndr.key"
                    >
                      {{ gndr?.value }}
                    </option>
                  </select>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.gender &&
                      employee_errors?.gender != null
                    "
                    >{{ employee_errors?.gender[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Birth Date <span class="text-danger">*</span></label
                  >
                  <div class="cal-icon">
                    <vue-datepicker
                      v-model="employee.birth_date_dd"
                      placeholder="Choose Date"
                      :max-date="maxDate"
                      :enable-time-picker="false"
                      :auto-apply="true"
                      :clearable="false"
                      :format="dateFormat"
                    />
                  </div>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.birth_date &&
                      employee_errors.birth_date != null
                    "
                    >{{ employee_errors?.birth_date[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Employee ID <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="employee.employee_id"
                    type="text"
                    class="form-control"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.employee_id &&
                      employee_errors.employee_id != null
                    "
                    >{{ employee_errors?.employee_id[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Joining Date <span class="text-danger">*</span></label
                  >
                  <div class="cal-icon">
                    <vue-datepicker
                      v-model="employee.joining_date_dd"
                      placeholder="Choose Date"
                      :max-date="maxDate"
                      :enable-time-picker="false"
                      :auto-apply="true"
                      :clearable="false"
                      :format="dateFormat"
                    />
                  </div>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.joining_date &&
                      employee_errors.joining_date != null
                    "
                    >{{ employee_errors?.joining_date[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-12">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Address <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="employee.address"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.address &&
                      employee_errors?.address != null
                    "
                    >{{ employee_errors?.address[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Address Line #2</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="employee.address_line_2"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.address_line_2 &&
                      employee_errors?.address_line_2 != null
                    "
                    >{{ employee_errors?.address_line_2[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">City</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="employee.city"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.city &&
                      employee_errors?.city != null
                    "
                    >{{ employee_errors?.city[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >State <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="employee.state_id"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.state_id &&
                      employee_errors?.state_id != null
                    "
                    >{{ employee_errors?.state_id[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Country</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="employee.country"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.country &&
                      employee_errors?.country != null
                    "
                    >{{ employee_errors?.country[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Pin Code/Zip Code <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="employee.pincode"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.pincode &&
                      employee_errors?.pincode != null
                    "
                    >{{ employee_errors?.pincode[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Phone Number <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="employee.contact_number"
                    class="form-control"
                    type="text"
                  />
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.contact_number &&
                      employee_errors.contact_number != null
                    "
                    >{{ employee_errors?.contact_number[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Company</label>
                  <select
                    v-model="employee.company_id"
                    class="form-select form-select-lg"
                  >
                    <option
                      v-for="cmpny in Companies"
                      :key="cmpny.id"
                      :value="cmpny.id"
                    >
                      {{ cmpny.company_name }}
                    </option>
                  </select>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.company_id &&
                      employee_errors.company_id != null
                    "
                    >{{ employee_errors?.company_id[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Department <span class="text-danger">*</span></label
                  >
                  <select
                    v-model="employee.department_id"
                    class="form-select form-select-lg"
                  >
                    <option
                      v-for="dprtmnt in Departments"
                      :key="dprtmnt.id"
                      :value="dprtmnt.id"
                    >
                      {{ dprtmnt.name }}
                    </option>
                  </select>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.department_id &&
                      employee_errors.department_id != null
                    "
                    >{{ employee_errors?.department_id[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Position <span class="text-danger">*</span></label
                  >
                  <select
                    v-model="employee.designation_id"
                    class="form-select form-select-lg"
                    @change="designation_change(employee.designation_id)"
                  >
                    <option
                      v-for="desgntn in Designations"
                      :key="desgntn.id"
                      :value="desgntn.id"
                    >
                      {{ desgntn.name }}
                    </option>
                  </select>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.designation_id &&
                      employee_errors.designation_id != null
                    "
                    >{{ employee_errors?.designation_id[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Office <span class="text-danger">*</span></label
                  >
                  <select
                    v-model="employee.office_id"
                    class="form-select form-select-lg"
                  >
                    <option
                      v-for="ofc in offices"
                      :key="ofc.office_id"
                      :value="ofc.office_id"
                    >
                      {{ ofc.office_name }}
                    </option>
                  </select>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors.office_id &&
                      employee_errors.office_id != null
                    "
                    >{{ employee_errors?.office_id[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Reports To </label>
                  <select
                    class="form-select form-select-lg"
                    v-model="employee.reports_to"
                  >
                    <option :value="selfid">-- Self --</option>
                    <option
                      v-for="rprtr in Reporters"
                      :key="rprtr.id"
                      :value="rprtr.id"
                    >
                      {{ rprtr?.first_name }} {{ rprtr?.last_name }}
                    </option>
                  </select>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.reports_to &&
                      employee_errors?.reports_to != null
                    "
                    >{{ employee_errors?.reports_to[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Status <span class="text-danger">*</span></label
                  >
                  <select
                    class="form-select form-select-lg"
                    v-model="employee.status"
                  >
                    <option value="">Select Status</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.status &&
                      employee_errors?.status != null
                    "
                    >{{ employee_errors?.status[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Termination Notification Date</label
                  >
                  <div class="cal-icon">
                    <datepicker
                      v-model="employee.termination_date_dd"
                      placeholder="Choose Date"
                      class="form-control datetimepicker"
                      :editable="true"
                      :clearable="false"
                      :input-format="dateFormat"
                    />
                  </div>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.termination_date &&
                      employee_errors?.termination_date != null
                    "
                    >{{ employee_errors?.termination_date[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Last Working Date</label>
                  <div class="cal-icon">
                    <datepicker
                      v-model="employee.relieving_date_dd"
                      placeholder="Choose Date"
                      class="form-control datetimepicker"
                      :editable="true"
                      :clearable="false"
                      :input-format="dateFormat"
                    />
                  </div>
                  <span
                    class="text-danger"
                    v-if="
                      employee_errors &&
                      employee_errors?.relieving_date &&
                      employee_errors?.relieving_date != null
                    "
                    >{{ employee_errors?.relieving_date[0] }}</span
                  >
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-flex" style="padding-right: 10px">
                  <label class="col-form-label"
                    >Face Recognization Enabled :
                  </label>
                  <div class="form-switch">
                    <input
                      @change="handleChangeEvent()"
                      v-model="employee.is_face_recognization_enabled"
                      type="checkbox"
                      class="form-check-input"
                      id="customSwitch3"
                      value="true"
                      :checked="employee.is_face_recognization_enabled"
                    />
                    <span
                      class="text-danger"
                      v-if="
                        employee_errors &&
                        employee_errors?.is_face_recognization_enabled &&
                        employee_errors?.is_face_recognization_enabled != null
                      "
                      >{{
                        employee_errors?.is_face_recognization_enabled[0]
                      }}</span
                    >

                    <label class="form-check-label" for="customSwitch3"></label>
                  </div>
                </div>
              </div>
              <div
                class="col-md-12 border-right"
                v-if="employee.is_face_recognization_enabled"
              >
                <div class="input-block mb-3">
                  <label class="col-form-label">Upload Face Image </label>
                  <Field
                    name="face_file"
                    type="file"
                    class="form-control"
                    @change="handleFaceFileUpload($event)"
                    accept=".png,.jpg,'.jpeg"
                    ref="importFaceFile"
                  />
                  <div class="invalid-feedback">
                    <span
                      class="text-danger"
                      v-if="
                        employee_errors &&
                        employee_errors?.face_file &&
                        employee_errors?.face_file != null
                      "
                      >{{ employee_errors?.face_file[0] }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="submit-section">
              <button
                class="btn btn-primary submit-btn"
                :disabled="disableButton"
                @click.prevent="editEmployee"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { notification } from "ant-design-vue";
import { Form, Field } from "vee-validate";
import axios from "axios";
export default {
  emits: ["reload-data"],
  data() {
    return {
      face_file: null,
      selfid: 0,
      selectedImage: null,
      genders: [
        {
          key: "",
          value: "Select",
        },
        {
          key: "f",
          value: "Female",
        },
        {
          key: "m",
          value: "Male",
        },
        {
          key: "o",
          value: "Others",
        },
      ],
      errors: null,
      employee_errors: {},
      confirm_password_error: null,
      disableButton: false,
      dateFormat: "dd-MM-yyyy",
      maxDate: new Date(),
      employee: {
        first_name: null,
        last_name: null,
        username: null,
        email: null,
        password: null,
        confirm_password: null,
        kiosk_pin: null,
        kiosk_confirm_pin: null,
        employee_id: null,
        gender: null,
        joining_date_dd: null,
        birth_date_dd: null,
        address: null,
        address_line_2: null,
        city: null,
        state_id: null,
        country: null,
        pincode: null,
        contact_number: null,
        company_id: null,
        office_id: null,
        department_id: null,
        designation_id: null,
        joining_date: null,
        birth_date: null,
        permission: null,
        reports_to: null,
        status: "",
        termination_date_dd: null,
        termination_date: null,
        relieving_date_dd: null,
        relieving_date: null,
      },
      permissions: {
        holiday: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        employee: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        department: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        designation: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        wages: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        schedule: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        shift: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        admin_leave: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        client: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        project: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        task: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        team: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        chat: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        asset: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        timing_sheet: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        overtime: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_setting: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        admin_attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        incident: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        office: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        organization_document: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        employee_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        daily_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        attendance_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        export_attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        global_setting: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        face_recognization: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        emp_bgv: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
      },
      offices: [],
    };
  },
  props: {
    employeeData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    clearEMP: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  watch: {
    clearEMP(newVal) {
      if (newVal) {
        this.defaultPermission();
        this.employee = {
          first_name: null,
          last_name: null,
          username: null,
          email: null,
          password: null,
          confirm_password: null,
          kiosk_pin: null,
          kiosk_confirm_pin: null,
          employee_id: null,
          gender: null,
          joining_date_dd: null,
          birth_date_dd: null,
          address: null,
          address_line_2: null,
          city: null,
          state_id: null,
          country: null,
          pincode: null,
          contact_number: null,
          company_id: null,
          office_id: null,
          department_id: null,
          designation_id: null,
          joining_date: null,
          birth_date: null,
          permission: null,
          reports_to: null,
          status: "",
          termination_date_dd: null,
          termination_date: null,
          relieving_date_dd: null,
          relieving_date: null,
        };
        this.employee_errors = {};
        this.selectedImage = null;
      }
    },
    employeeData(newVal) {
      if (newVal && newVal != 1) {
        this.employee = newVal;
        this.employee.joining_date_dd = newVal?.joining_date
          ? new Date(newVal?.joining_date)
          : null;
        this.employee.birth_date_dd =
          newVal?.birth_date != null ? new Date(newVal?.birth_date) : null;
        this.employee.termination_date_dd = newVal?.termination_date
          ? new Date(newVal?.termination_date)
          : null;
        this.employee.relieving_date_dd = newVal?.relieving_date
          ? new Date(newVal?.relieving_date)
          : null;

        this.employee.password = null;
        this.employee.confirm_password = null;
        this.employee.kiosk_pin = newVal?.kiosk_pin ?? null;
        this.employee.kiosk_confirm_pin = null;

        if (
          newVal &&
          newVal?.user_permission &&
          newVal?.user_permission?.permissions &&
          newVal?.user_permission?.permissions != null
        ) {
          const permission_data = JSON.parse(
            newVal?.user_permission?.permissions
          );
          if (permission_data && permission_data != null) {
            this.permissions = permission_data;
          }
        }
      }
    },
    "employee.first_name": {
      handler: "generateEmail",
      immediate: true,
    },
    "employee.last_name": {
      handler: "generateEmail",
      immediate: true,
    },
    "employee.company_id": {
      handler: "generateEmail",
      immediate: true,
    },
  },
  components: {
    Form,
    Field,
  },
  methods: {
    ...mapMutations(["SET_EMPLOYEE_SEARCH_FIELD"]),
    ...mapActions([
      "fetchCompanies",
      "fetchDesignations",
      "fetchDepartments",
      "getDateFormate",
      "fetchEmployees",
      "updateEmployee",
      "fetchOffice",
      "updateProfile",
      "fetchEmployeeProfileData",
      "fetchReporters",
    ]),
    async handleImageChange() {
      const formData = new FormData(this.$refs.uploadImageFrm);
      const response = await this.updateProfile({
        data: formData,
        id: this?.employeeData?.id,
      });
      if (response.status == 200) {
        if (response?.data?.employee?.avatar != null) {
          this.selectedImage =
            process.env.VUE_APP_IMAGE_BASE_URL +
            response?.data?.employee?.avatar;
        }

        await this.fetchEmployeeProfileData(this?.employeeData?.id);
        this.$emit("reload-data");
        notification.open({
          message: "Successfully Profile Changed",
          placement: "topRight",
          duration: process.env.VUE_APP_NOTIFICATION_DURATION,
          style: {
            background: process.env.VUE_APP_SUCCESS_COLOR,
          },
        });
      } else {
        this.selectedImage = null;
        notification.open({
          message: response?.message
            ? response?.message
            : "Something went wrong, Please try again later",
          placement: "topRight",
          duration: process.env.VUE_APP_NOTIFICATION_DURATION,
          style: {
            background: process.env.VUE_APP_WARNING_COLOR,
          },
        });
      }
    },
    handleChangeEvent() {
      let is_face_recognization_enabled =
        this?.employee?.is_face_recognization_enabled === true ? 1 : 0;

      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var user_id = this?.employee?.id || "";

      axios
        .put("update-face-recognization-status/" + user_id, {
          is_face_recognization_enabled: is_face_recognization_enabled,
        })
        .then((response) => {
          loader.hide();

          notification.open({
            message: response?.data?.message || "Successful",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$emit("reload-data");
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error?.response?.status == 401 &&
            response?.data?.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            notification.open({
              message: response?.data?.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    designation_change(selected_designation_id = null) {
      var record = this.Designations.find(function (item) {
        return item.id === selected_designation_id;
      });

      if (
        record &&
        record?.permissions &&
        record?.permissions != "null" &&
        record?.permissions != null
      ) {
        const permission_data = JSON.parse(record?.permissions);
        if (permission_data && permission_data != null) {
          this.$nextTick(() => {
            this.permissions = permission_data;
          });
        } else {
          this.defaultPermission();
        }
      } else {
        this.defaultPermission();
      }
    },
    handleFaceFileUpload(event) {
      this.face_file = event.target.files[0];
    },
    restrictKioskPin(event, field) {
      const value = event.target.value.replace(/\D/g, "").slice(0, 4);
      this.employee[field] = value || null;
    },
    async editEmployee() {
      this.confirm_password_error != null;
      this.disableButton = true;
      this.employee_errors = null;
      this.employee.joining_date = this.employee?.joining_date_dd
        ? await this.getDateFormate(this.employee?.joining_date_dd)
        : null;
      this.employee.birth_date = this.employee?.birth_date_dd
        ? await this.getDateFormate(this.employee?.birth_date_dd)
        : null;

      this.employee.termination_date = this.employee?.termination_date_dd
        ? await this.getDateFormate(this.employee?.termination_date_dd)
        : "";
      this.employee.relieving_date = this.employee?.relieving_date_dd
        ? await this.getDateFormate(this.employee?.relieving_date_dd)
        : "";

      this.employee.permission = this.permissions;

      if (
        this.employee.password != null &&
        this.employee.password != this.employee.confirm_password
      ) {
        this.confirm_password_error =
          "Password and Confirm Password not matching";
        this.disableButton = false;
        return;
      }

      if (this.employee.password == null || this.employee.password == "") {
        delete this.employee.password;
        delete this.employee.confirm_password;
      }

      if (
        this.employee.kiosk_pin &&
        this.employee.kiosk_pin !== this.employee.kiosk_confirm_pin
      ) {
        this.disableButton = false;
        return;
      }
      if (this.employee.kiosk_pin && this.employee.kiosk_pin.length !== 4) {
        this.employee_errors = {
          ...this.employee_errors,
          kiosk_pin: ["Kiosk PIN must be exactly 4 digits"],
        };
        this.disableButton = false;
        return;
      }
      delete this.employee.kiosk_confirm_pin;
      const pinValue =
        this.employee.kiosk_pin != null
          ? String(this.employee.kiosk_pin).trim()
          : "";
      if (pinValue === "") {
        delete this.employee.kiosk_pin;
      }

      //var form = new FormData();
      //form.append('face_file', this.face_file);

      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      if (this.face_file) {
        this.employee.updatefacefile = this.face_file;
      }

      axios
        .post(
          "/employee/updateemployee/" + this.employee.id,
          this.employee,
          config
        )
        .then((response) => {
          this.face_file = null;
          // this.$refs.importFaceFile.value = "";

          loader.hide();

          notification.open({
            message: response?.data?.message || "Successfully Updated",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.disableButton = false;

          this.$refs.update_employee_close.click();

          this.fetchEmployees();

          this.$emit("reload-data");

          this.SET_EMPLOYEE_SEARCH_FIELD(this.getEMployeeSeatchData);
        })
        .catch((error) => {
          this.disableButton = false;

          this.face_file = null;
          // this.$refs.importFaceFile.value = "";

          loader.hide();

          if (error.response) {
            var response = error.response;

            if (response.data && response.data.error) {
              this.employee_errors = response.data.error;
            }

            notification.open({
              message: response?.data?.message || "Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    defaultPermission() {
      this.permissions = {
        holiday: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        employee: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        department: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        designation: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        wages: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        schedule: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        shift: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        admin_leave: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        client: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        project: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        task: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        team: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        chat: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        asset: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        timing_sheet: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        overtime: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_setting: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        admin_attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        incident: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        office: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        organization_document: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        employee_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        daily_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        attendance_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        export_attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        global_setting: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        face_recognization: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        emp_bgv: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
      };
    },
    async fetchOffices() {
      await axios
        .get("/office/all")
        .then((response) => {
          var token = window.localStorage.getItem("token");
          axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          this.offices = response?.data?.data || [];
        })
        .catch((error) => {
          console.log("error in fetching employee", error);
        });
    },
    generateEmail() {
      if (!this.employee.id) {
        if (this.employee.first_name && this.employee.last_name) {
          const firstName = this.employee.first_name
            .toLowerCase()
            .replace(/\s+/g, "");
          const lastName = this.employee.last_name
            .toLowerCase()
            .replace(/\s+/g, "");
          this.employee.email = `${firstName}${lastName}@${this.companyDomain}`;
        } else if (this.employee.first_name) {
          const firstName = this.employee.first_name
            .toLowerCase()
            .replace(/\s+/g, "");
          this.employee.email = `${firstName}@${this.companyDomain}`;
        }
      }
    },
    resetEditError() {
      this.employee_errors = null;
      this.$emit("reload-data");
    },
  },
  computed: {
    ...mapGetters([
      "getCompanies",
      "getDesignations",
      "getDepartments",
      "getEMployeeSeatchData",
      "getOffice",
      "getReporter",
    ]),
    avatarSrc() {
      return this.employeeData?.avatar
        ? process.env.VUE_APP_IMAGE_BASE_URL + this.employeeData?.avatar
        : require("@/assets/img/profiles/avatar-01.jpg");
    },
    Companies() {
      return this.getCompanies?.record ? this.getCompanies.record : [];
    },
    companyDomain() {
      const defaultDomain = this.Companies[0].company_name;

      const selectedCompany = this.Companies.find(
        (c) => c.id === this.employee.company_id
      );
      return selectedCompany
        ? selectedCompany.company_name.toLowerCase().replace(/\s+/g, "") +
            ".com"
        : defaultDomain.toLowerCase().replace(/\s+/g, "") + ".com";
    },
    Designations() {
      return this.getDesignations ? this.getDesignations : [];
    },
    Departments() {
      return this.getDepartments ? this.getDepartments : [];
    },
    Office() {
      return this.getOffice?.data ? this.getOffice.data : [];
    },
    Reporters() {
      return this?.getReporter ? this?.getReporter : [];
    },
    kioskPinMismatch() {
      const pin = this.employee.kiosk_pin;
      const confirm = this.employee.kiosk_confirm_pin;
      return (
        pin != null &&
        pin !== "" &&
        confirm != null &&
        confirm !== "" &&
        pin !== confirm
      );
    },
  },
  async created() {
    // let loader = this.$loading.show({
    //   // Optional parameters
    //   container: this.$refs.formContainer,
    //   canCancel: false,
    // });
    await this.fetchCompanies();
    await this.fetchDepartments();
    await this.fetchDesignations();
    await this.fetchOffices();
    await this.fetchReporters();

    var getuser = localStorage.getItem("user");
    this.selfid = JSON.parse(getuser).id;
    // loader.hide();

    // const editmodal = document.getElementById("emp_edit_and_profile_update");
    // editmodal.addEventListener("hidden.bs.modal", this.resetEditError);

    if (this.$refs.empEditProfileUpdateModal) {
      this.$refs.empEditProfileUpdateModal.addEventListener(
        "hidden.bs.modal",
        this.resetEditError
      );
    }
  },
};
</script>
